/*
 * Copyright (c) 2026. Bolmate B.V.
 */
import React from 'react';

import fileText from '@iconify/icons-feather/file-text';

import {useTranslation} from 'react-i18next';

import BolmateSetupCard from './bolmateSetupCard';

interface Props {
    completed?: boolean;
    onClick?: () => void;
    onCheckClick?: () => void;
    className?: string;
}

export default function BolmateInvoiceDesignCard(props: Props) {
    const {completed, onClick, onCheckClick, className} = props;
    const {t} = useTranslation();

    return (
        <BolmateSetupCard
            className={className}
            title={t('controls.setupCard.invoiceDesign.title', 'Factuur ontwerpen')}
            subtitle={t('controls.setupCard.invoiceDesign.subtitle', 'Controleer en pas aan indien nodig')}
            icon={fileText}
            completed={completed}
            onClick={onClick}
            onCheckClick={onCheckClick}
        />
    );
}
